import { platformFetch } from "services/platformFetch";
import { auth } from "services/firebase";
export async function adminPublications(path = "", method = "GET", data) {
  if (!auth?.currentUser) throw new Error("Entre na sua conta para continuar.");
  const response = await platformFetch(`/api/admin/publications${path}`, {
    method,
    cache: "no-store",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${await auth.currentUser.getIdToken()}`,
    },
    ...(data ? { body: JSON.stringify(data) } : {}),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok)
    throw Object.assign(new Error(result.message || "Não foi possível acessar as publicações."), {
      code: result.code,
    });
  return result;
}
